/* ==========================================================================
   Surprise Stak product page — sections/main-product-surprise-stak.liquid.

   - Countdown strip: ticks every second to data-ss-end, then (surprise
     extension) on to data-ss-ext-end with the extension copy; hides after.
   - ?stak=reveal / ?stak=mystery previews the other campaign state.
   - Quantity stepper and add to bag: POST /cart/add.js. Rebuy's Smart Cart
     opens off that request; /cart itself redirects home on this store, so a
     native form submit would lose the shopper.
   - Product Sticky section: theme.js wires its button to the default PDP's
     form, which is not on this page, so this file takes it over (click and
     show-when-the-buy-row-scrolls-away).
   - "What's in the box" diagram scales down to fit a narrow column.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function say(page, text) {
    var live = $('[data-ss-live]', page);
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 50);
  }

  // ── Campaign state preview ────────────────────────────────────────────
  function initStatePreview(page) {
    var m = /[?&]stak=(mystery|reveal)\b/.exec(window.location.search);
    if (m) page.setAttribute('data-ss-state', m[1]);
  }

  // ── Countdown ─────────────────────────────────────────────────────────
  function initCountdown(page) {
    var strip = $('[data-ss-strip]', page);
    var timer = $('[data-ss-timer]', page);
    var end = Date.parse(page.getAttribute('data-ss-end') || '');
    var extEnd = Date.parse(page.getAttribute('data-ss-ext-end') || '');
    if (!strip || !timer || isNaN(end)) return;

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var interval;
    function tick() {
      var now = Date.now();
      var d = end - now;
      // Past the first deadline: run on to the surprise extension if there is one.
      if (d <= 0 && !isNaN(extEnd) && extEnd > now) {
        page.setAttribute('data-ss-phase', 'extended');
        d = extEnd - now;
      }
      if (d <= 0) {
        strip.hidden = true;
        window.clearInterval(interval);
        return;
      }
      var days = Math.floor(d / 864e5); d -= days * 864e5;
      var h = Math.floor(d / 36e5); d -= h * 36e5;
      var m = Math.floor(d / 6e4); d -= m * 6e4;
      var s = Math.floor(d / 1e3);
      timer.textContent = days + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    tick();
    interval = window.setInterval(tick, 1000);
  }

  // ── Quantity + add to bag ─────────────────────────────────────────────
  function initBuy(page) {
    var form = $('[data-ss-form]', page);
    if (!form) return null;
    var input = $('[data-ss-qty-input]', form);
    var addBtn = $('[data-ss-add]', form);

    function qty() {
      var n = parseInt(input.value, 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }

    $$('[data-ss-qty]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = Math.max(1, qty() + parseInt(btn.getAttribute('data-ss-qty'), 10));
      });
    });
    input.addEventListener('change', function () { input.value = qty(); });

    function add() {
      if (!addBtn || addBtn.classList.contains('loading')) return;
      var sticky = $('.product-sticky-bottom [data-add-to-cart]');
      addBtn.classList.add('loading');
      if (sticky) sticky.classList.add('loading');

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: qty() }] })
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body && body.description || 'add failed');
            return body;
          });
        })
        .then(function (body) {
          // Rebuy opens itself off the /cart/add.js request. Only nudge it
          // once it is ready: show() while it is initialising wedges it.
          var sc = window.Rebuy && window.Rebuy.SmartCart;
          if (sc && sc.status === 'ready' && typeof sc.show === 'function') sc.show();
          // Same Klaviyo "Added to Cart" event the default PDP sends.
          var item = body.items && body.items[0];
          if (item && window._learnq) {
            window._learnq.push(['track', 'Added to Cart', {
              Name: item.title,
              ImageURL: item.image,
              Price: (item.price / 100).toFixed(2),
              ProductID: item.product_id,
              VariantID: item.variant_id,
              Quantity: item.quantity
            }]);
          }
          say(page, 'Added the Surprise Stak to your bag.');
        })
        .catch(function (err) {
          say(page, err && err.message && err.message !== 'add failed'
            ? err.message
            : 'Sorry, that could not be added to your bag. Please try again.');
        })
        .then(function () {
          addBtn.classList.remove('loading');
          if (sticky) sticky.classList.remove('loading');
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      add();
    });

    return { form: form, add: add, row: form };
  }

  // ── Product Sticky section ────────────────────────────────────────────
  function initSticky(buy) {
    var bar = $('.product-sticky-bottom');
    if (!bar || !buy) return;

    // Capture phase on document runs before theme.js's own listener on the
    // button, which would look for the default PDP form.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.product-sticky-bottom [data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (!btn.disabled) buy.add();
    }, true);

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      // Show the bar only once the buy row has scrolled up out of view.
      var above = entry.boundingClientRect.top < 0;
      bar.style.display = !entry.isIntersecting && above ? 'block' : 'none';
    }).observe(buy.row);
  }

  // ── Diagram scaling ───────────────────────────────────────────────────
  function initDiagram(page) {
    var wrap = $('[data-ss-diagram-wrap]', page);
    var diagram = $('[data-ss-diagram]', page);
    if (!wrap || !diagram) return;

    function fit() {
      diagram.style.transform = '';
      wrap.style.height = '';
      var scale = Math.min(1, wrap.clientWidth / diagram.offsetWidth);
      if (scale < 1) {
        diagram.style.transform = 'scale(' + scale + ')';
        wrap.style.height = Math.ceil(diagram.offsetHeight * scale) + 'px';
        wrap.style.justifyContent = 'flex-start';
      } else {
        wrap.style.justifyContent = '';
      }
    }
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(wrap);
    else window.addEventListener('resize', fit);
  }

  // ── Reveal hero: the product's own media ─────────────────────────────
  // Videos carry data-src and load only when their slide is shown in the
  // reveal state, so the mystery days never download them. Autoplay is
  // muted and looping, with a pause button; reduced motion starts paused.
  function initGallery(page) {
    var gallery = $('[data-ss-gallery]', page);
    if (!gallery) return;
    var slides = $$('[data-ss-slide]', gallery);
    var thumbs = $$('[data-ss-thumb]', gallery);
    var pauseBtn = $('[data-ss-pause]', gallery);
    if (!slides.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var userPaused = reduce;

    function revealOn() { return page.getAttribute('data-ss-state') === 'reveal'; }

    function load(video) {
      if (video.__ssLoaded) return;
      video.__ssLoaded = true;
      $$('source[data-src]', video).forEach(function (s) { s.src = s.getAttribute('data-src'); });
      video.load();
    }

    function sync() {
      var active = $('.ss-slide.is-active', gallery);
      var video = active && $('video', active);
      var anim = active && $('[data-ss-anim]', active);
      $$('video', gallery).forEach(function (v) { if (v !== video) v.pause(); });
      // Animated images pause by swapping in their still frame.
      slides.forEach(function (sl) { sl.classList.toggle('is-still', userPaused); });
      if (pauseBtn) {
        var noun = video ? 'video' : 'animation';
        pauseBtn.hidden = !video && !anim;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', (userPaused ? 'Play ' : 'Pause ') + noun);
      }
      if (!video || !revealOn()) return;
      load(video);
      if (userPaused) video.pause();
      else {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function show(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-pressed', n === i ? 'true' : 'false');
      });
      sync();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-ss-thumb'), 10)); });
    });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        sync();
      });
    }
    sync();
  }

  // ── Other looping GIFs (how to use): pause swaps in a still ──────────
  function initMotion(page) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-ss-motion]', page).forEach(function (box) {
      var btn = $('[data-ss-motion-toggle]', box);
      function set(still) {
        box.classList.toggle('is-still', still);
        if (!btn) return;
        btn.setAttribute('aria-pressed', still ? 'true' : 'false');
        btn.setAttribute('aria-label', still ? 'Play animation' : 'Pause animation');
      }
      set(reduce);
      if (btn) btn.addEventListener('click', function () { set(!box.classList.contains('is-still')); });
    });
  }

  function init() {
    var page = $('[data-ss]');
    if (!page || page.__ss) return;
    page.__ss = true;
    initStatePreview(page);
    initGallery(page);
    initMotion(page);
    initCountdown(page);
    initSticky(initBuy(page));
    initDiagram(page);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
